<template>
<div id="wrapper" class="pb-5 mb-5  h-100vh">
	<section class="scrollbar rgtrStps">
	    <div class="container registerStes-form">
	        <div class="row align-items-center justify-content-center h-100">
	            <div class="col-12 col-lg-6">
	            	<loader v-if="pageLoader && !$parent.pageLoader"></loader>
	                <div class="customFotm stepsRegular position-relative bg-white border-radius-5 p-md-5 p-3">
	                	<span class="alert alert-danger" v-if="submitted && errors.has('timing')">Please select the timing when you are available</span>
                    	<h2 class="text-center themecolor mb-4">On-Board Call</h2>
                    	<!-- <h2 class="text-center mb-4">Select Timing When u are available to take call</h2> -->
                        <div class="row onBoardCall my-y" v-if="options.ONBOARDING_TIMINGS">
                            <div class="col-12">
                            	<div class="form-group">
                            		<span class="onbt text-center mb-4"><img width="300" src="../../../../static/website/images/call_center.svg" alt="Icon"></span>
                                    <div class="position-relative">
                                        <select class="form-control" name="timing" v-model="timing" v-validate="'required'">
                                        	<option value="" disabled>Select timing</option>
                                        	<option :value="item.id" v-for="item,key in options.ONBOARDING_TIMINGS">{{getTiming(item.slot_from)}} - {{getTiming(item.slot_to)}}</option>
                                        </select>
                                        
                                    </div>
		                        </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group text-center mt-4 mb-0">
                                    <button class="btn btn-link btn-blue" @click.stop.prevent="submit()">Submit</button>
                                </div>
                            </div>
                        </div>
	                </div>
	            </div>
	        </div>
	    </div>
	</section>
</div>
</template>
<script>
	import * as types from '@/types'
	import { mapActions } from 'vuex'
	export default {
		name: 'payment-mode',
		data() {
			return {
				pageLoader: false,
                notification_msg:'',
                notification_type:'',
				submitted: false,
				timing: '',
			}
		},
		components: {},
		props:{
			options: {
		      default: {}
		    }
		},
		methods: {
			getTiming(item){
				item = parseInt(item)
				return (item < 12)?item+' AM':(item == 12)?item+' PM':item-12+' PM'
			},
			...mapActions({
				_runRegisterStep3: types.RUN_REGISTER_STEP3,
				_runGetRegisterStepData: types.RUN_GET_USER_REGISTERATION_STEP_DATA,
			}),
			changeMembership(){
				if(this.memberShip != 1){
					this.member_type = ''
				}
			},
			submit() {
				const _that = this
				this.submitted = true;
				this.$validator.validate().then(valid => {
					if (valid) {
						let input_json = {
							'globalParams': {
								"onboard_timing_id" : _that.timing
							},
							'localParams': {
								"parameter": _that
							}
						}
						_that._runRegisterStep3(input_json)
					}
				})
			}
		},
		created(){
			this._runGetRegisterStepData({'globalParams': {"step" : "3"},'localParams': {"parameter": this,'step':'3'}})
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/website/registerSteps/step3.vue